import { Injectable } from '@angular/core';
import { ButtonName } from '@app/components/booking-flow/booking-flow.component';
import { Pet } from '@app/models/pet.model';
import { Site } from '@app/models/site.model';
import { ClientApiService } from '@app/services/api/client-api.service';
import { PosApiService } from '@app/services/api/pos-api.service';
import { UserAccountApiService } from '@app/services/api/user-account-api.service';
import { AuthTokenService } from '@app/services/auth-token.service';
import { ConfigService } from '@app/services/config/config.service';
import { ErrorDialogService as NewErrorDialogService } from '@app/services/error-dialog.service';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService, PET_LIST } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { PetService } from '@app/services/pet.service';
import { UserAccountService as NewUserAccountService } from '../../app/services/user-account.service';
import { ContentService } from './content.service';
import { ErrorDialogService } from './error-dialog.service';

@Injectable({
    providedIn: 'root',
})
export class UserAccountService extends NewUserAccountService {
    constructor(
        private _userAccountApiService: UserAccountApiService,
        private _posApiService: PosApiService,
        private _authTokenService: AuthTokenService,
        private _localStorageService: LocalStorageService,
        private _errorDialogService: ErrorDialogService,
        private _clientApiService: ClientApiService,
        private _featureFlagService: FeatureFlagService,
        private _petService: PetService,
        private _navigationService: NavigationService,
        private _contentService: ContentService,
        private readonly _configService: ConfigService,
        private _newErrorDialogService: NewErrorDialogService
    ) {
        super(
            _userAccountApiService,
            _posApiService,
            _authTokenService,
            _localStorageService,
            _newErrorDialogService,
            _clientApiService,
            _featureFlagService,
            _petService,
            _navigationService,
            _contentService,
            _configService
        );
    }

    protected openErrorDialog(message: string) {
        this._errorDialogService.openErrorDialog(message);
    }

    public handleAccountCreation(site: Site, selectedStepIndex: number, navigateToRoute: (selectedStep: any) => void) {
        const storedPetListData = this._localStorageService.get(PET_LIST) as Pet[];
        const hasPetListInfo = storedPetListData?.length > 0;
        this._contentService.isAccountCreatedFromClientScreen = true;
        if (selectedStepIndex === this._contentService.steps?.find((x) => x.stepRoute === 'booking/client')?.index) {
            if (!site?.supportsPets) {
                this._contentService.stepper?.next();
                this._contentService.selectedStepIndex = this._contentService.stepper?.selectedIndex;
                const selectedStep = this._contentService.steps?.find((x) => x.buttonText === ButtonName.SubmitRequest);
                this._contentService.buttonName = selectedStep?.buttonText ?? this._contentService.steps[0].buttonText;
                navigateToRoute(selectedStep);
            } else {
                this.setPetScreenNavigation(hasPetListInfo);
            }
        } else if (
            this._contentService.selectedStepIndex === this._contentService.steps?.find((x) => x.stepRoute === 'booking/datetime')?.index
        ) {
            if (site?.supportsPets) {
                this.setPetScreenNavigation(hasPetListInfo);
            }
        }
    }
}
